"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = require("underscore");

var _underscore2 = _interopRequireDefault(_underscore);

var _constant = require("../../constant");

var _constant2 = _interopRequireDefault(_constant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handler = function handler() {
  var self = this;
  return new Promise(function (res, rej) {
    var isResolved = false;
    var isRejected = false;
    setTimeout(function () {
      if (!isResolved) {
        isRejected = true;
        rej("METHOD_CALLBACK_TIMEOUT");
      }
    }, _constant2.default.DEFAULT_TIMEOUT_LIMIT);
    return self.invoke(101).then(function (data) {
      if (!isRejected) {
        isResolved = true;
        res(data);
      }
    });
  });
};

var name = {
  "x-token": [{
    pattern: {
      "IOS|FINO": ["gte", "1.0.0"],
      "ANDROID|FINO": ["gte", "1.0.0"]
    }
  }, {
    pattern: {
      "IOS|FINO": ["gte", "1.0.0"],
      "ANDROID|FINO": ["gte", "1.0.0"]
    }
  }]
};

var Info = _underscore2.default.mapObject(name, function (v, k) {
  return v.map(function (p) {
    return {
      pattern: p.pattern,
      handler: handler
    };
  });
});

exports.default = Info;